/* eslint-disable */
import React, { useState } from "react";

const NewInfoIcon = ({ popupContent }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 22,
        height: 22,
        background: "rgba(16, 16, 16, 0.22)",
        borderRadius: 6,
        cursor: "pointer",
        zIndex: 20,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span
        style={{
          color: "white",
          fontSize: 14,
          fontWeight: "700",
          lineHeight: 1,
        }}
      >
        i
      </span>

      {/* Tooltip */}
      <div
        style={{
          position: "absolute",
          top: "5px",
          right: "30px", // moves tooltip to top-right outside
          transform: "translateY(-100%)",
          width: "240px",
          maxWidth: "70vw", // responsive for mobile
          padding: "10px",
          // background: "rgba(0,0,0,0.85)",
          background: "#0000009e",
          color: "white",
          borderRadius: "6px",
          fontSize: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
          zIndex: 9999, // always on top
          opacity: isHovered ? 1 : 0,
          pointerEvents: isHovered ? "auto" : "none",
          transition: "opacity 0.25s ease",
        }}
      >
        {popupContent}
      </div>
    </div>
  );
};

export default NewInfoIcon;